var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options)?_c('div',{staticClass:"maina"},[_c('Echart',{attrs:{"options":_vm.options,"id":"progressDom","height":"7rem"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }